import { concat, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { t } from 'ember-intl';
import { gt } from 'ember-truth-helpers';

import Button from 'umg-ember-backend/components/ui/button';
import { Codemirror } from 'umg-ember-backend/components/ui/codemirror';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const tScope = 'record_detail.forms.a11y_report.nodes.';
const bem = getBem(styles);

export class Nodes extends Component {
  // Defaults
  @tracked nodesCount = 5;

  // Getter and setter
  get nodes() {
    return this.args.nodes.slice(0, this.nodesCount);
  }

  // Functions
  showMore = () => {
    if (this.nodesCount < this.args.nodes.length) {
      this.nodesCount += 10;
    }
  };

  // Template
  <template>
    <div class={{(bem)}}>
      {{#each this.nodes as |node|}}
        <div class={{bem 'node' (hash is=node.verdict)}}>
          <p>{{node.description}}</p>
          {{#each node.elements as |element|}}
            <Codemirror
              @value={{element.htmlCode}}
              @readOnly={{true}}
              @mode='html'
            />
            {{element.pointer}}<br />
          {{/each}}
        </div>
      {{/each}}
      {{#if (gt @nodes.length this.nodesCount)}}
        <Button
          @label={{t (concat tScope 'show_more')}}
          {{on 'click' this.showMore}}
        />
      {{/if}}
    </div>
  </template>
}
